import {
  GET_USERS,
  GET_USER,
  ASSIGN_USER_TO_ROUTES,
  REMOVE_USER_FROM_ROUTES,
  REMOVE_USERS_FROM_ROUTES,
  GET_USERS_FOR_ROUTE,
  ASSIGN_USERS_TO_ROUTE,
  SYNC_USERS,
  CLEAR_USERS,
  GET_USERS_BY_ID
} from "../constants/action-types";

// INITIALIZE STATE
const initialState = {
  users: {},
  user: {},
  assignedUsers: {},
  continuationToken: {
    base: null,
    search: null
  },
  instanceId: null,
  statusOutput: null
};

function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

function createUser(serverUser) {
  let routesObject = {};

  serverUser.Routes.forEach(routeKey => {
    routesObject[routeKey] = true;
  });

  var name = "";
  if (serverUser.GivenName !== null) {
    name = `${serverUser.GivenName} ${serverUser.Surname}`;
  } else {
    name = toTitleCase(`${serverUser.DisplayName}`);
  }

  const user = {
    id: serverUser.id,
    name: name,
    email: serverUser.Email,
    routes: routesObject
  };

  return user;
}

// REDUCER
export const UserReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USERS: {
      let userList = action.payload.Users;
      let continuationToken = action.payload.ContinuationToken;
      let cached = action.payload.cached;
      let searched = action.payload.searched;

      const users = cached ? Object.assign({}, state.users) : {}

      userList.forEach(user => {
        users[user.id] = createUser(user);
      });

      var continuationData = {
        base: searched ? null : continuationToken,
        search: searched ? continuationToken : null
      }

      return {
        ...state,
        users,
        continuationToken: continuationData
      };
    }

    case GET_USERS_BY_ID: {
      let userList = action.payload;

      const newUsers = {}

      userList.forEach(user => {
        newUsers[user.id] = user;
      });
      return {
        ...state,
        assignedUsers: newUsers
      }
    }

    case CLEAR_USERS: {
      return {
        ...state,
        users: {}
      }
    }

    case SYNC_USERS: {
      var existingInstanceId = action.payload.id || action.payload.instanceId
      const success = action.payload.output?.success
      const runtimeStatus = action.payload.runtimeStatus

      const newState = { ...state }

      if (existingInstanceId == null || success) {
        newState.statusOutput = runtimeStatus
        newState.instanceId = null

      } else {
        newState.instanceId = existingInstanceId
        newState.statusOutput = runtimeStatus
      }

      return newState
    }

    case GET_USER: {
      const user = createUser(action.payload);

      let users = Object.assign({}, state.users);
      users[user.id] = user

      return {
        ...state,
        user,
        users
      };
    }
    case ASSIGN_USER_TO_ROUTES: {
      let userId = action.payload.userId;
      let routeIds = action.payload.routeIds;

      let users = Object.assign({}, state.users);

      if (users[userId]?.routes != null) {
        users[userId].routes = [];
      }

      routeIds.forEach(routeId => {
        users[userId].routes[routeId] = true;
      });

      // Update the individual user too...
      const user = Object.assign({}, users[userId]);

      return {
        ...state,
        users,
        user
      };
    }
    case REMOVE_USER_FROM_ROUTES: {
      let userId = action.payload.userId;
      let routeIds = action.payload.routeIds;

      let users = Object.assign({}, state.users);
      let assignedUsers = Object.assign({}, state.assignedUsers)

      if (assignedUsers.hasOwnProperty(userId)) {
        delete assignedUsers[userId];
      }

      if (!users[userId].hasOwnProperty("routes")) {
        users[userId].routes = [];
      }

      routeIds.forEach(routeId => {
        delete users[userId].routes[routeId];
      });

      // Update the individual user too...
      const user = Object.assign({}, users[userId]);

      return {
        ...state,
        users,
        user,
        assignedUsers
      };
    }
    case REMOVE_USERS_FROM_ROUTES: {
      let userIds = action.payload.userIds;
      let activeRouteId = action.payload.activeRouteId;
      let routeIds = action.payload.routeIds;
      let assignedUsers = Object.assign({}, state.assignedUsers)

      let users = Object.assign({}, state.users);
      let user = {};

      userIds.forEach(userId => {
        if (!users[userId].hasOwnProperty("routes")) {
          users[userId].routes = [];
        }

        routeIds.forEach(routeId => {
          if (routeId === activeRouteId) {
            delete assignedUsers[userId]
          }

          delete users[userId].routes[routeId];
        });

        if (state.user.id === userId) {
          // Update the individual user too...
          user = Object.assign({}, users[userId]);
        }

      });

      return {
        ...state,
        users,
        user,
        assignedUsers
      };
    }
    case ASSIGN_USERS_TO_ROUTE: {
      let userIds = action.payload.userIds;
      let routeId = action.payload.routeId;

      let users = Object.assign({}, state.users);
      let assignedUsers = Object.assign({}, state.assignedUsers);

      userIds.forEach(userId => {
        if (!users[userId].hasOwnProperty("routes")) {
          users[userId].routes = [];
        }

        users[userId].routes[routeId] = true;
        assignedUsers[userId] = users[userId];
      });

      return {
        ...state,
        users,
        assignedUsers
      };
    }
    case GET_USERS_FOR_ROUTE: {
      let usersInRouteList = action.payload;
      const assignedUsers = {};

      usersInRouteList.forEach(user => {
        const createdUser = createUser(user);
        assignedUsers[createdUser.id] = createdUser;
      });

      return {
        ...state,
        assignedUsers
      };
    }
    default:
      return state;
  }
};
